"use strict";
define(
'stores/submissions',[
	"jquery",
	"stores/store",
	"actions/submissions",
	"constants/actiontypes"
],
function ($, StoreBase, Action, Constants)
{
	Store.prototype = new StoreBase();
	Store.constructor = Store;

	function Store (params)
	{
		// Call parent constructor
		StoreBase.call(this, params);
		
		// Setup the instance
		this.submissions = {};
		this.sectionCache = {};
		this.registerDispatchListener(function (action) {
			var self = this;
			switch(action.actionType) {
				case Constants.CREATED_SUBMISSION:
					this.clearAllSectionCache();
					if (Array.isArray(action.data)) {
						_.each(action.data, function (data, index, list) {
							this.addSubmission(data);
						}, this);
					} else {
						this.addSubmission(action.data);
					}

					this.event.emit("change");
					break;
				case Constants.UPDATED_SUBMISSION:
					this.clearAllSectionCache();
					if(this.submissions[action.submissionId]) {
						_.each(action.data, function(value, key) {
							self.submissions[action.submissionId][key] = value;
						});
					}
					else {
						console.log("Error - Submission not found.");
					}

					this.event.emit("change");
					break;
				case Constants.CREATED_SUBMISSION_RESPONSE:
					if(this.submissions[action.submissionId]) {
						var responses = this.submissions[action.submissionId].responses;
						responses.push(action.data);
						this.submissions[action.submissionId].responses = responses;
					}
					else {
						console.log("Error - Submission not found.");
					}
					this.event.emit("change");
					break;
				case Constants.UPDATED_SUBMISSION_RESPONSE:
					this.clearAllSectionCache();
					if(this.submissions[action.submissionId]) {
						var idx;
						for(idx = 0; idx < this.submissions[action.submissionId].responses.length; idx++) {
							if(this.submissions[action.submissionId].responses[idx].guid == action.responseId) {
								break;
							}
						}
						if(idx == this.submissions[action.submissionId].responses.length) {
							console.log("Error - Response not found.");							
							break;
						}

						_.each(action.data, function(value, key) {
							self.submissions[action.submissionId].responses[idx][key] = value;
						});
					}
					else {
						console.log("Error - Submission not found.");
					}

					this.event.emit("change");
					break;
				case Constants.DELETED_SUBMISSION_RESPONSE:
					this.clearAllSectionCache();
					if(this.submissions[action.submissionId]) {
						var idx;
						for(idx = 0; idx < this.submissions[action.submissionId].responses.length; idx++) {
							if(this.submissions[action.submissionId].responses[idx].guid == action.responseId) {
								break;
							}
						}
						if(idx == this.submissions[action.submissionId].responses.length) {
							console.log("Error - Response not found.");							
							break;
						}

						self.submissions[action.submissionId].responses.splice(idx, 1);
					}
					else {
						console.log("Error - Submission not found.");
					}

					this.event.emit("change");
					break;
				case Constants.CLEAR_SECTION_CACHE:
					this.clearSectionCache(action.data.section_guid);
			}
		}.bind(this));

		this.action = new Action();
	}

	Store.prototype.addSubmission = function(data)
	{
		this.submissions[data.id.toLowerCase()] = data;
	};

	Store.prototype.getAll = function (filterOptions)
	{
		var submissions;
		if(filterOptions) {
			if(typeof filterOptions.classId == "string") {
				filterOptions.classId = [filterOptions.classId];
			}

			var ConnectToStores = require("shared/connect-to-stores");
			submissions = _.filter(this.submissions, function(submission) {
				if(filterOptions.ownerId && submission.owner_guid != filterOptions.ownerId)
					return;

				var assignment = ConnectToStores.assignments.get(submission.assignment_guid);
				if(!assignment || (filterOptions.classId && filterOptions.classId.indexOf(assignment.section_guid) < 0))
					return;

				return submission;
			});
		}
		else {
			submissions = _.map(this.submissions, function(submission) {
				return submission;
			});
		}

		return submissions;
	}

	Store.prototype.hasSubmission = function(id)
	{
		return (id.toLowerCase() in this.submissions);
	}

	Store.prototype.getSubmission = function(id)
	{
		return this.submissions[id.toLowerCase()];
	}

	Store.prototype.clearAllSectionCache = function(){
		if(this.sectionCache)
			this.sectionCache = {};
	};

	Store.prototype.clearSectionCache = function(sectionId){
		delete this.sectionCache[sectionId]
	};

	Store.prototype.filterBySection = function (sectionId)
	{
		if (sectionId in this.sectionCache) {
			return this.sectionCache[sectionId];
		}

		var submissions = [];
		_.each(this.submissions, function (item, index, list)
		{
			_.each(item.recipients, function(recipient, recipientIndex, recipientList)
			{
				if (recipient.data.type === "section" && recipient.data.section_guid.toLowerCase() == sectionId.toLowerCase()) {
					submissions.push(item);
				}
			}, this);
		}, this);
		
		this.sectionCache[sectionId] = submissions;

		return submissions;
	}

	Store.prototype.filterByAssignment = function (assignmentId, sortOption=null) {
		var filtered = [];

		_.each(this.submissions, function (item, index, list)
		{
			if (item.assignment_guid.toLowerCase() == assignmentId.toLowerCase()) {
				filtered.push(item);
			}
		}, this);


		if (sortOption) {
			if (sortOption === "name") {
				filtered.sort(function (a, b) {
					return a.owner_name.localeCompare(b.owner_name)
				});
			}
		}

		return filtered;
	}

	Store.prototype.filterByAssignments = function (assignmentIds) {
		var self = this;
		var filtered = [];

		_.each(assignmentIds, function(assignment) {
			_.each(self.submissions, function (item, index, list)
			{
				if (item.assignment_guid.toLowerCase() == assignment.toLowerCase()) {
					filtered.push(item);
				}
			}, this);
		});

		return filtered;
	}

	Store.prototype.filterByStudent = function (studentId)
	{
		var filtered = [];
		_.each(this.submissions, function (item, index, list)
		{
			if(item.owner_guid == studentId) {
				filtered.push(item);
			}
		}, this);

		return filtered;
	}

	Store.prototype.filterByStudents = function (studentIds)
	{
		var set_students = new Set(studentIds);
		var filtered = [];
		_.each(this.submissions, function (item, index, list)
		{
			if(set_students.has(item.owner_guid)) {
				filtered.push(item);
			}
		}, this);

		return filtered;
	}

	Store.prototype.filterByAssignmentForStudent = function (assignmentId, studentId)
	{
		for(var submission_guid in this.submissions) {
			if (this.submissions[submission_guid].assignment_guid.toLowerCase() === assignmentId.toLowerCase() 
				&& this.submissions[submission_guid].owner_guid.toLowerCase() === studentId.toLowerCase()) {
				return this.submissions[submission_guid];
			}
		}

		return null;
	}

	return Store;
});

